import { makeVar } from '@apollo/client';
import { defaultClassFilters } from './utils';

export const searchResultsVar = makeVar(null);

export const filteredResultsVar = makeVar([]);

export const filtersVar = makeVar({
  stops: {
    nonStop: {
      disabled: true,
      selected: false,
    },
    oneStop: {
      disabled: true,
      selected: false,
    },
    twoStops: {
      disabled: true,
      selected: false,
    },
  },
  flightTimes: {
    landing: {
      maxDateTime: 0,
      minDateTime: 0,
      selected: [0, 1],
    },
    takeOff: {
      maxDateTime: 0,
      minDateTime: 0,
      selected: [0, 1],
    },
  },
  minMaxPrice: {
    max: 0,
    min: 0,
    minForPriceSlider: 0,
    selected: 0,
    currency: 'USD',
  },
  airlines: [],
  classes: defaultClassFilters,
});

export const searchSelectionsVar = makeVar(null);

export const bookingProfileVar = makeVar({});

export const selectedDepartureVar = makeVar(null);

export const selectedReturnVar = makeVar(null);

export const shouldSearchReturnResultsVar = makeVar(false);

export const heldReservationVar = makeVar(null);

export const bookedReservationVar = makeVar(null);

export const browseParamsVar = makeVar(null);

export const searchParamsVar = makeVar(null);

export const prefixPathVar = makeVar('');

export const paymentVar = makeVar(null);

export const paramsVar = makeVar(null);

export const filterPanelVar = makeVar(null);

export const searchTypeVar = makeVar(null);

export const giftCardPaymentVar = makeVar(null);

export const globalDataVar = makeVar({
  country: '',
  language: '',
});

export const currentSailingVar = makeVar(null);

export const loyaltyDataVar = makeVar(null);
